import React, {useCallback, useEffect, useState} from 'react';
import {Box, IconButton, LinearProgress, SvgIcon, TableCell, TableRow, Typography, useMediaQuery} from "@mui/material";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import {executeQueryUtil} from "../../../utils/gqlUtil";
import ClipLoaderComponent from "../../../components/ClipLoaderComponent";
import GeneralResult from "../../../components/CrudFrom/GeneralResult";
import * as GraphUtils from "../../../Graphs/BarGraphUtils";
import {filterSingleDay} from "../../Home/FilterInfoOverview";
import PieTurnover from "../../../Graphs/PieTurnover";
import {byStaffMode} from "../../../Graphs/constants";
import {getStaffsQuery} from "../../../gql/StaffGql";
import ChevronDownIcon from "@untitled-ui/icons-react/build/esm/ChevronDown";
import ChevronRightIcon from "@untitled-ui/icons-react/build/esm/ChevronRight";
import StaffDetail from "./StaffDetail";
import cloneDeep from "clone-deep";
import {formatMinutesToHours} from "../../../utils/timeUtil";
import {NO_DATA} from "../../../utils/constants";
import {formatTotal} from "../../../utils/currencyUtil";

export function getTableCellDynStyle(lgUp) {
    return {minWidth: lgUp ? 120 : 80, padding: lgUp ? "8px" : "1px"}
}

const Results = ({className, ...rest}) => {
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
    const { currentBrand, currentEstablishment, orders, sumUpDays,
        filter, mergedSumUpDay, loading , staffWorks} = useAuth();
    const [itemSource, setItemSource] = useState(null);
    const [itemSourceFiltered, setItemSourceFiltered] = useState(null);
    const [maxSale, setMaxSale] = useState(0);
    const [maxCount, setCount] = useState(0);
    const [currentStaff, setCurrentStaff] = useState(null);

    const handleStaffToggle = useCallback((staffId) => {
        setCurrentStaff((prevStaffId) => {
            if (prevStaffId === staffId) {
                return null;
            }

            return staffId;
        });
    }, []);

    function completeStaffData(staffs) {
        if (!orders && !sumUpDays) {
            return staffs;
        }


        if (filter?.filterType === filterSingleDay) {

            staffs.forEach(staff => {
                let totalInfo = GraphUtils.getTotalInfoByStaff(staff, orders);
                staff.count = totalInfo.count;
                staff.total = totalInfo.total;
            })
        }
        else {
            staffs.forEach(staff => {
                if (mergedSumUpDay && mergedSumUpDay.detailbyStaff) {
                    let totalInfo = GraphUtils.getTotalInfoBySumUpDayByStaff(staff, mergedSumUpDay);
                    staff.count = totalInfo.count;
                    staff.total = totalInfo.total;
                } else {
                    staff.count = 0;
                    staff.total = 0;
                }
            })
        }


        const maxSale = Math.max(...staffs.map(x => x.total));
        const maxCount = Math.max(...staffs.map(x => x.count));

        setMaxSale(maxSale);
        setCount(maxCount);

        staffs.forEach(staff => {
            staff.countRatio = Math.floor(100 * (staff.count / maxCount));
            staff.totalRatio = Math.floor(100 * (staff.total / maxSale));
        })

        return staffs;
    }

    useEffect(() => {
        if (!currentBrand() || !currentEstablishment()) {
            return;
        }

        async function setItemSourceAsync() {
            // setLoading(true);
            let res = await executeQueryUtil(getStaffsQuery(currentBrand().id, currentEstablishment().id));
            // let products = res?.data?.getProducts.map(x => JSON.parse(x.content));
            // products = completeStaffData(products);

            let staffDatas = res.data.getStaffs;
            staffDatas = cloneDeep(staffDatas);
            staffDatas = completeStaffData(staffDatas);
            setItemSource(staffDatas)
            setItemSourceFiltered([...staffDatas])
        }
        setItemSourceAsync();
    }, [currentBrand(), currentEstablishment(), orders, filter, mergedSumUpDay]);




    function getColor(ratio) {
        if (ratio >= 66) {
            return 'success';
        }
        if (ratio >= 33) {
            return 'warning';
        }
        return 'error';
    }

    function getTotalWorkTime(item) {
        if (filter?.filterType === filterSingleDay) {
            if (!staffWorks) {
                return 0;
            }

            if (!item.rhId) {
                return NO_DATA;
            }
            const rhId = item.rhId;

            const staffWork = (staffWorks || []).find(staffWork => staffWork.externalId == rhId);

            if (!staffWork) {
                return NO_DATA;
            }

            return (formatMinutesToHours(staffWork.totalWorkMinutes));
        }
        else if (mergedSumUpDay) {
            const detailStaff = mergedSumUpDay.detailbyStaff[item.id];
            if (detailStaff && detailStaff.totalWorkMinutes) {
                const formatMinutesToHours1 = formatMinutesToHours(detailStaff.totalWorkMinutes);
                return formatMinutesToHours1;
            }
            return NO_DATA;
        }

    }

    const getTableCellColumn = () => {

        // if (lgUp) {
        return (
                <>
                    <TableCell
                        sx={{
                            witdth: '25px',
                            padding: lgUp ? 0 : 'inherit',
                        }}
                    />
                    <TableCell sx={getTableCellDynStyle(lgUp)}>
                        {localStrings.name}
                    </TableCell>
                    <TableCell sx={getTableCellDynStyle(lgUp)}>
                        {localStrings.totalSales}
                    </TableCell>
                    <TableCell sx={getTableCellDynStyle(lgUp)}>
                        {localStrings.salesCount}
                    </TableCell>
                    <TableCell sx={getTableCellDynStyle(lgUp)}>
                        {localStrings.totalWorked}
                    </TableCell>
                </>
            )
        // }
        // return (
        //     <>
        //         <TableCell width="15%"/>
        //         <TableCell width="15%">
        //             {localStrings.name}
        //         </TableCell>
        //         <TableCell width="20%">
        //             {localStrings.totalSales}
        //         </TableCell>
        //         <TableCell width="20%">
        //             {localStrings.salesCount}
        //         </TableCell>
        //         <TableCell width="20%">
        //             {localStrings.totalWorked}
        //         </TableCell>
        //     </>
        // )
    }

    const getTableCell = (item) => {
        return(
            <>
                <TableRow>
                    <TableCell
                        padding="checkbox"
                        sx={{
                            ...(item.id === currentStaff ? {
                                position: 'relative',
                                '&:after': {
                                    position: 'absolute',
                                    content: '" "',
                                    top: 0,
                                    left: 0,
                                    backgroundColor: 'primary.main',
                                    width: 3,
                                    height: 'calc(100% + 1px)'
                                },
                                witdth: '25px',
                                padding: lgUp ? 0 : 'inherit',
                                // padding: lgUp ? 0 : 'inherit'

                            }
                            :
                            {
                                witdth: '25px',
                                padding: lgUp ? 0 : 'inherit',
                            }
                            )
                        }}
                    >
                        <IconButton
                            onClick={() => handleStaffToggle(item.id)}
                            sx={{
                                padding: lgUp ? '8px' : '1px', // Réduction maximale du padding
                                minWidth: 0,                  // Évite les tailles minimales trop larges
                                width: lgUp ? '24px' : 'auto',
                                height: lgUp ? '24px' : 'auto',
                            }}
                        >
                            <SvgIcon fontSize="small">
                                {item.id === currentStaff ? <ChevronDownIcon /> : <ChevronRightIcon />}
                            </SvgIcon>
                        </IconButton>
                    </TableCell>
                    <TableCell sx={getTableCellDynStyle(lgUp)}>
                        {item.name}
                    </TableCell>
                    <TableCell sx={getTableCellDynStyle(lgUp)}>
                        <LinearProgress
                            value={item.totalRatio}
                            variant="determinate"
                            color={getColor(item.totalRatio)}
                            sx={{
                                height: 8,
                                width: '100%',
                                marginRight: lgUp ? '0px' : '5px'
                            }}
                        />
                        <Typography
                            color="text.secondary"
                            variant="body2"
                        >
                            {formatTotal(item.total) + " €"}
                        </Typography>
                    </TableCell>
                    <TableCell sx={{
                        minWidth: lgUp ? 120 : 80,
                        padding: lgUp ? "8px" : "1px",
                        margin: lgUp ? '0 0px' : '5 5px'
                    }}>
                        <LinearProgress
                            value={item.countRatio}
                            variant="determinate"
                            color={getColor(item.countRatio)}
                            sx={{
                                height: 8,
                                width: '100%',
                                marginRight: lgUp ? '0px' : '5px'
                            }}
                        />
                        <Typography
                            color="text.secondary"
                            variant="body2"
                        >
                            {
                                item.count
                            }
                        </Typography>
                    </TableCell>

                    <TableCell sx={getTableCellDynStyle(lgUp)}>{getTotalWorkTime(item)}</TableCell>
                </TableRow>


                {item.id === currentStaff &&
                    <TableRow>
                        <TableCell
                            colSpan={7}
                            sx={{
                                p: 0,
                                position: 'relative',
                                '&:after': {
                                    position: 'absolute',
                                    content: '" "',
                                    top: 0,
                                    left: 0,
                                    backgroundColor: 'primary.main',
                                    width: 3,
                                    height: 'calc(100% + 1px)'
                                }
                            }}
                        >
                            <StaffDetail
                                // mapOptionOptionList={mapOptionOptionList}
                                staff = {itemSource.find(p => p.id === currentStaff)}/>
                        </TableCell>
                    </TableRow>
                }
                {/*}*/}
            </>
        )
    }



    const sortOptions = [
        {
            value: 'name|asc',
            label: localStrings.name
        },
        {
            value: 'total|desc',
            label: localStrings.sale
        },
        {
            value: 'count|desc',
            label: localStrings.count
        },
        // {
        //     value: 'totalWorkMinutes|desc',
        //     label: localStrings.totalWorked
        // },
    ];

    return (
        <>
            {/*<p>{itemSourceFiltered && itemSourceFiltered.length}</p>*/}
            { (itemSource && !loading) ?
                // <Box sx={{ overflowX: 'auto', width: '100%' }}>
                    <GeneralResult
                        // className={className}
                        getPathToData={(result) => result}
                        getTableCell={getTableCell}
                        getTableCellColumn={getTableCellColumn}
                        doNotUseTableRow
                        sortOptions={sortOptions}
                        searchProperties={['name']}
                        itemsSource={itemSourceFiltered}
                        tabs={[
                            {
                                value: 'distribution',
                                label: localStrings.distribution,
                                component:
                                    <>
                                        {loading ?
                                            <ClipLoaderComponent/>
                                            :
                                            <PieTurnover displayMode={byStaffMode}/>
                                        }
                                    </>


                            },
                        ]}
                    >

                    </GeneralResult>
                // </Box>
                :
                <ClipLoaderComponent/>
            }
        </>
    )

};


export default Results;
